import { z } from 'zod';
import { insuranceClaimsNoticeOwnerFactUnavailableReasonSchema } from './insurance-claims-documents-notice-artifact.contract.js';
export const insuranceClaimsCommunicationsNoticeDeliveryCapability = 'communications.insurance-claim-notice-delivery.v1';
export const insuranceClaimsCommunicationsNoticeDeliverySlot = 'insurance-claims.notice-delivery';
export const insuranceClaimsCommunicationsNoticeDeliveryProviderId = 'communications.server.insurance-claims-notice-delivery';
const idSchema = z.string().uuid();
const sha256Schema = z.string().regex(/^[a-f0-9]{64}$/);
export const insuranceClaimsNoticeDeliveryStateSchema = z.enum([
    'queued', 'sent', 'delivered', 'failed', 'suppressed',
]);
export const insuranceClaimsCommunicationsNoticeDeliveryProviderRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(insuranceClaimsCommunicationsNoticeDeliveryCapability),
    resourceType: z.literal('insurance-claims.aob-notice'),
    resourceId: idSchema,
    projectId: idSchema,
});
export const insuranceClaimsCommunicationsNoticeDeliveryFactSchema = z.strictObject({
    capability: z.literal(insuranceClaimsCommunicationsNoticeDeliveryCapability),
    noticeId: idSchema,
    projectId: idSchema,
    messageId: idSchema,
    threadId: idSchema,
    sourceVersion: z.number().int().positive(),
    contentHash: sha256Schema,
    channel: z.enum(['email', 'sms']),
    state: insuranceClaimsNoticeDeliveryStateSchema,
    sentAt: z.string().datetime({ offset: true }).nullable(),
    deliveredAt: z.string().datetime({ offset: true }).nullable(),
    observedAt: z.string().datetime({ offset: true }),
}).superRefine((value, context) => {
    if (['sent', 'delivered'].includes(value.state) && value.sentAt === null) {
        context.addIssue({ code: 'custom', path: ['sentAt'], message: 'Sent facts require sentAt.' });
    }
    if ((value.state === 'delivered') !== (value.deliveredAt !== null)) {
        context.addIssue({
            code: 'custom', path: ['deliveredAt'], message: 'Only delivered facts carry deliveredAt.',
        });
    }
});
export const insuranceClaimsCommunicationsNoticeDeliveryProviderResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(insuranceClaimsCommunicationsNoticeDeliveryCapability),
    noticeId: idSchema,
    projectId: idSchema,
    facts: z.array(insuranceClaimsCommunicationsNoticeDeliveryFactSchema).max(500),
}).superRefine((value, context) => {
    const messageIds = value.facts.map(({ messageId }) => messageId);
    if (new Set(messageIds).size !== messageIds.length) {
        context.addIssue({ code: 'custom', path: ['facts'], message: 'Delivery facts must be unique.' });
    }
    value.facts.forEach((fact, index) => {
        if (fact.noticeId !== value.noticeId || fact.projectId !== value.projectId) {
            context.addIssue({
                code: 'custom', path: ['facts', index],
                message: 'Delivery facts must belong to the requested notice and Project.',
            });
        }
    });
});
export const insuranceClaimsCommunicationsNoticeDeliveryAvailabilitySchema = z.discriminatedUnion('state', [
    insuranceClaimsCommunicationsNoticeDeliveryProviderResponseSchema,
    z.strictObject({
        state: z.literal('unavailable'),
        capability: z.literal(insuranceClaimsCommunicationsNoticeDeliveryCapability),
        reasonCode: insuranceClaimsNoticeOwnerFactUnavailableReasonSchema,
    }),
]);
//# sourceMappingURL=insurance-claims-communications-notice-delivery.contract.js.map